import React from "react";
import { config } from "../../config/config";
import { getSdk } from "../../services/sdkService";
import { EpisodesSelector, Detail, Loading } from "../../services/visualLibraryService";
import { getSupportedVideoTechnology } from "../../services/assetTypesService";
import { getSeasonsAndEpisodesList } from "../../utils/mediaDataRetrieval";
import {
  DetailPageStyled,
  ArrowScrollStyled,
  DetailContainerStyled,
  DetailWrapperStyled,
  DisclaimerText,
  IconStyled,
  DisclaimerTextStyled
} from "./styles/Styled";
import { withAppState, getAppState } from "../../state";
import { resolution } from "../../config/ui/resolutionConfig";
import { showAndReportUserRelatedError } from "../../errors/utils";
import {
  getGlobalButtonInfo,
  getGlobalButtonFocusPath,
  getConfigForModalWithCloseButton
} from "../../errors/globalButtons";
import sorter from "../../utils/sortObjectsArray";
import { isUserSubscribedToChannel, isAddonContent, isChampionsTrophyAddOn } from "../../utils/subscriptionUtils";
import { i18n } from "../../services/i18nService";
import { isUserAccountActive } from "../../services/accountStatusService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import {
  showResolutionModal,
  showNotLoggedModal,
  showRetryOrBackModal,
  showForceLogoutError,
  showExpiredContentModal
} from "../../services/modalsService";
import { formatDetailData, getEpisodeLabel } from "../../services/copyService";
import { trackPage, trackEvent, sendUserEvent } from "../../services/analyticsService";
import {
  getTrailerVideoData,
  getVideoDataForPlayer,
  getMediaContentData,
  buyAssetDetails,
  getExpireTagTime,
  expirationDate,
  getYouboraPrams
} from "../../services/mediaService";
import { getUserMediaLists, myListHandler, checkMediaListsData } from "../../services/mediaListService";
import {
  redirectTo,
  trackAndRedirectHandler,
  getNavigationReferences,
  isComingFromDetailPageScope
} from "../../services/navigationService";
import {
  isSuitableFor4KPlayback,
  getTrailer,
  getSeasonsList,
  isSeriesDetailPage,
  getSeasonEpisodeFromMediaGuid,
  findFirstEpisodeBySeason,
  has4KProgramId,
  getEpisodeSelectorData
} from "../../services/titleDataService";
import getRemoteKey from "../../services/remoteService";
import { isSupportedDeviceForMobileLite, showUnSupportedDeviceErrorPopup } from "../../utils/mobileLiteUtils";
import { routes } from "../../routes";
import {
  isTVODContent,
  isSVODContent,
  getAssetPrices,
  redirectToBuyBrandsPage,
  isTVODPriority,
  isSVODPriority,
  isContentActive,
  isTvodExpired,
  isTvodFlowForPlayback,
  setCurrentStatusForPlayer,
  getBuyBrandsInfoObjChampionsTrophy
} from "../../utils/tvodUtils";
import { getTVODAssetsStatus } from "../../services/tvodService";
import * as Sentry from "@sentry/react";
import { startApp } from "../../index";

const HAS_4K = "4kProgramId";
const MEDIAGUID = "mediaGuid";
const PAGE = "detail";
const PAGE_EPISODE = "episodeSelector";
const PLAY_FROM_LABEL = "details_screen";
const BUTTONS_LIST_NONMOVIES = ["buttonPlay", "buttonTrailer", "buttonWatchlist", "buttonRestart", "buttonBuy"];
const EPISODEFOCUS = "episodesCarousel";
const SEASONFOCUS = "seasonsCarousel";
const CONNECTEDTV = "Connected TV";
const SVOD = "SVOD";
const EXPIRED = "expired";
let sdk = null;
let SendAnalyticsCallEpisodeOnce = true;
let fromWhere = null;

class DetailPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.isExiting = false;
    // FIXME this state is too cluttered (too many elements are added to it when not needed). Not only here, across all the component
    this.state = {
      titleData: null,
      backgroundCover: undefined,
      video: undefined,
      trailer: undefined,
      hasEpisodes: false,
      episodeSelectorLoaded: false,
      isSavedInMyWatchlist: false,
      has4K: false,
      isLoaded: false,
      hasAllDataLoaded: false,
      firstEpisodeAvailable: undefined,
      isPlaying: false,
      slidePage: 0
    };

    this.fetchData = this.fetchData.bind(this);
    this.playHandler = this.playHandler.bind(this);
    this.handleEnter = this.handleEnter.bind(this);
    this.tvodBtnText = this.tvodBtnText.bind(this);
    this.DisclaimerText = this.DisclaimerText.bind(this);
    this.assetHandler = this.assetHandler.bind(this);
    this.play = this.play.bind(this);
    this.getVideoData = this.getVideoData.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onBack = this.onBack.bind(this);
    this.isRestarting = false;
    this.clearRefreshTimeout = null;
    this.props.stateActions.applyKidsTheme();
    this.isSeries = isSeriesDetailPage.call(this);
  }

  async componentWillReceiveProps(newProps) {
    if (newProps.location.pathname !== this.props.location.pathname) {
      if (
        (this.props.location && this.props.location.state && !!this.props.location.state.deepLinkReferrer) ||
        (newProps.location && newProps.location.state && !!newProps.location.state.deepLinkReferrer)
      ) {
        this.setState({ backgroundCover: null, hasEpisodes: false, hasAllDataLoaded: false });
        this.props.onRef(this);
      }
      this.props.applicationState.userMediaCached = null;
      this.progress = null;
      this.setState({ titleData: null });
      this.setState({ titleData: await this.fetchData() });
    }
  }

  componentWillUnmount() {
    this.isExiting = true;
    this.mounted = false;
    if (this.clearRefreshTimeout) {
      clearTimeout(this.clearRefreshTimeout);
    }
    this.clearRefreshTimeout = null;
    !!getAppState().globalModal && this.props.stateActions.hideGlobalModal();
    document.removeEventListener("keydown", this.keydownHandler);
  }

  keydownHandler = e => {
    const pressedKey = getRemoteKey(e.keyCode);
    if (pressedKey === "MEDIA_PLAY") {
      this.playHandler(false);
    } else if (pressedKey === "ARROW_DOWN") {
      if (
        this.state.hasEpisodes &&
        this.seasonsList &&
        this.episodesList &&
        BUTTONS_LIST_NONMOVIES.indexOf(this.props.applicationState.currentFocus) > -1
      ) {
        this.props.setFocus(EPISODEFOCUS);
        this.setState({
          slidePage: -resolution.detail.positionListEpisodesDown
        });

        if (SendAnalyticsCallEpisodeOnce === true) {
          trackPage.call(this, PAGE_EPISODE);
          SendAnalyticsCallEpisodeOnce = false;
        }
      }
    } else if (pressedKey === "ARROW_UP") {
      if (
        this.state.hasEpisodes &&
        this.seasonsList &&
        this.episodesList &&
        this.props.applicationState.currentFocus === SEASONFOCUS
      ) {
        this.props.setFocus(BUTTONS_LIST_NONMOVIES[0]);
        this.setState({
          slidePage: resolution.detail.positionListEpisodesUp
        });
      }
    }
  };

  async componentDidMount() {
    this.props.setFocus(BUTTONS_LIST_NONMOVIES[0]);

    const getPlatform = await getSdk().systemManager.device.getPlatform();
    this.setState({
      isOnPS4: getPlatform === "ps4" ? true : false
    });
    const { history, location } = this.props;
    this.mounted = true;
    document.addEventListener("keydown", this.keydownHandler);
    if (!isComingFromDetailPageScope.call(this)) {
      // This will happen when the deep linking is used and in this case the media list cache needs to be removed in
      // order to get the new title's media list data and not show the previous one's.
      this.props.applicationState.userMediaCached = null;
      this.progress = null;
    }

    location.state && !!location.state.deepLinkReferrer && (await startApp());
    trackPage.call(this, PAGE);
    this.setState({
      titleData: await this.fetchData(),
      isLoaded: true,
      isPlaying: false
    });
    this.props.onRef(this);
    fromWhere = this.props.location.referrer;
    // Send event
    !this.state.unAuthorizedAccess &&
      this.props.applicationState.userLogged &&
      this.props.location.referrer.search(/\/(episodes|player)$/) === -1 &&
      this.props.location.referrer !== this.props.location.pathname &&
      sendUserEvent({
        module_id: history.location.state ? history.location.state.moduleId : null,
        id: this.state.id,
        action: "detail_page"
      });

    await this.updateEpisodeData();
    await this.checkUpdatedEpisodes();
    // Force logout listening
    showForceLogoutError.call(this);
    await this.reloadWait(1000);
    if (this.props.applicationState.currentFocus === "episodesCarousel") {
      this.setState({
        slidePage: -resolution.detail.positionListEpisodesDown
      });
    }
  }

  reloadWait(ms) {
    return new Promise(resolve => (this.clearRefreshTimeout = setTimeout(resolve, ms)));
  }
  closeModal(focusPath = Detail.defaultFocusPath) {
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(focusPath);
  }

  async updateEpisodeData() {
    const { history, location } = this.props;
    history.replace({
      ...location,
      state: {
        ...(await getEpisodeSelectorData.call(this)),
        from: location?.state?.from
      }
    });
    this.setState({ hasAllDataLoaded: true });
  }

  getDataToSentBuyAsset(addonContent = null) {
    const {
      applicationState: { addons }
    } = this.props;
    const addOn = addonContent || this.state.addonContent;
    const infoObj = getBuyBrandsInfoObjChampionsTrophy(addons, addOn);
    return {
      title: this.state.title,
      addonContent: addOn,
      titleId: this.state.id,
      price: null,
      isCTStandalone: infoObj?.CTAddOnData?.isCTStandalone,
      isChampionsTrophyAddOn: isChampionsTrophyAddOn(addOn)
    };
  }

  async playHandler(isRestarting) {
    const {
      match: {
        params: { titleId }
      },
      applicationState: { userLogged, userAccountStatus, addons, currentFocus },
      setFocus,
      stateActions
    } = this.props;
    let eventAction = (isRestarting === true && "play_from_beginning") || "play";
    trackEvent(PAGE, eventAction, titleId);
    const boundCloseModal = this.closeModal.bind(this, currentFocus);
    if (userLogged) {
      const { isTVOD, assetPrices } = this.state;

      const tvodStatus = isTVOD && (await getTVODAssetsStatus(titleId));

      if (isTVOD && isTvodExpired(tvodStatus)) {
        const { rentCtaData, purchaseCtaData } = assetPrices || {};

        if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length !== 0) {
          return showExpiredContentModal.call(this, this.closeModal, assetPrices);
        } else if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length === 0) {
          return trackAndRedirectHandler.call(
            this,
            PAGE,
            "rentLabel",
            routes.buyasset,
            buyAssetDetails.call(this, "rentLabel", rentCtaData)
          );
        } else {
          return trackAndRedirectHandler.call(
            this,
            PAGE,
            "purchaseLabel",
            routes.buyasset,
            buyAssetDetails.call(this, "purchaseLabel", purchaseCtaData)
          );
        }
      }

      if (!isTvodFlowForPlayback(tvodStatus)) {
        if (!isUserAccountActive(userAccountStatus) && !isAddonContent(this.state.addonContent)) {
          return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset());
        }

        if (!isUserSubscribedToChannel(addons, this.state.addonContent)) {
          return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset());
        }

        if (!this.isThisDeviceSupported) {
          return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
        }
      }

      this.isRestarting = isRestarting;
      if (!!getAppState().isOnline) {
        await showResolutionModal.call(this, isSuitableFor4KPlayback(has4KProgramId.call(this)));
      } else {
        stateActions.showGlobalModal(
          getConfigForModalWithCloseButton(
            {
              title: i18n.get("global.errors.internetConnectivity.title"),
              text: i18n.get("global.errors.internetConnectivity.text")
            },
            boundCloseModal
          )
        );
        setFocus(getGlobalButtonFocusPath("close"));
      }
      // Add GA Event on play button if there is no error
      trackEvent("play", "video_play_click", titleId);
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
    return false;
  }

  async handleEnter(episodeTitle) {
    const {
      match: {
        params: { titleId }
      },
      applicationState: { userLogged, userAccountStatus, addons }
    } = this.props;
    const { isTVOD, assetPrices } = this.state;
    if (userLogged) {
      const { rentCtaData, purchaseCtaData } = assetPrices || {};
      const tvodStatus = isTVOD && (await getTVODAssetsStatus(titleId));
      if (isTVOD && tvodStatus && (isTvodExpired(tvodStatus) || tvodStatus.length === 0)) {
        if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length !== 0) {
          const modifiedPrices = { isOnDetail: true, ...assetPrices };
          return showExpiredContentModal.call(this, this.closeModal, modifiedPrices);
        } else if (Object.keys(rentCtaData).length !== 0 && Object.keys(purchaseCtaData).length === 0) {
          return trackAndRedirectHandler.call(
            this,
            PAGE,
            "rent",
            routes.buyasset,
            buyAssetDetails.call(this, "rent", rentCtaData)
          );
        } else {
          return trackAndRedirectHandler.call(
            this,
            PAGE,
            "purchase",
            routes.buyasset,
            buyAssetDetails.call(this, "purchase", purchaseCtaData)
          );
        }
      }

      if (!isTvodFlowForPlayback(tvodStatus)) {
        if (!isUserAccountActive(userAccountStatus) && !isAddonContent(episodeTitle.addonContent)) {
          return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(episodeTitle.addonContent));
        }
        if (!isUserSubscribedToChannel(addons, episodeTitle.addonContent)) {
          return redirectToBuyBrandsPage.call(this, this.getDataToSentBuyAsset(episodeTitle.addonContent));
        }
      }

      if (!this.isThisDeviceSupported) {
        return showUnSupportedDeviceErrorPopup.call(this, this.closeModal);
      }
      this.episodeTitle = episodeTitle;
      showResolutionModal.call(this, isSuitableFor4KPlayback(this.episodeTitle["4kProgramId"]));
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
    return false;
  }

  async checkUpdatedEpisodes() {
    const {
      history: {
        location: { state }
      }
    } = this.props;
    if (fromWhere === routes.player) {
      try {
        const updatedEpisodes = await getSeasonsAndEpisodesList(state.seriesId, true);
        Object.assign(state, {
          episodesList: state.episodesList.map((episode, index) =>
            Object.assign(episode, updatedEpisodes.episodesList[index])
          ),
          lastEpisode: updatedEpisodes.lastEpisode
        });
        this.setState({ isLoaded: true });
      } catch (e) {
        this.setState({ isLoaded: true });
      }
    }

    this.setState({ isLoaded: true });
  }

  goPlayer(videoData) {
    const { history } = this.props;
    this.isExiting = true;
    this.setState({
      isPlaying: true
    });
    const { state } = history.location;
    if (state && state.from) {
      delete state.from;
    }
    return redirectTo.call(this, routes.player, {
      ...state,
      ...videoData
    });
  }

  async play(is4K, isSelectedFromResolutionPopup) {
    if (this.props.applicationState.currentFocus !== "episodesCarousel") {
      const {
        setFocus,
        match: {
          params: { titleId }
        }
      } = this.props;
      const episodesLoaded = !this.isSeries || (await this.episodesLoad);
      const videoData = episodesLoaded && (await getVideoDataForPlayer.call(this, is4K));
      Object.assign(videoData, { playFrom: PLAY_FROM_LABEL });
      isSelectedFromResolutionPopup && trackEvent(PAGE, is4K ? "4K" : "HD", titleId);
      sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
      setFocus(Detail.defaultFocusPath);
      this.goPlayer(videoData);
    } else {
      const {
        location: {
          state: { seriesId }
        },
        setFocus,
        stateActions: { hideGlobalModal }
      } = this.props;
      !!getAppState().globalModal && hideGlobalModal();
      const videoData = await this.getVideoData(is4K);
      if (this.mounted) {
        isSelectedFromResolutionPopup && trackEvent("detail", is4K ? "4K" : "HD", seriesId);
        trackEvent(
          "detail",
          "play_from_episode_selector",
          `${seriesId}-S${this.episodeTitle.tvSeasonNumber}E${this.episodeTitle.tvSeasonEpisodeNumber}`
        );
        sessionStorage && sessionStorage.setItem("seriesPlaying4K", is4K);
        setFocus(EpisodesSelector.defaultFocusPath);
        redirectTo.call(this, routes.player, videoData);
      }
    }
  }

  // FIXME There is a really similar function in DetailPage.js, we should have the logic in one place only
  async getVideoData(is4K) {
    const { location } = this.props;
    const media = is4K
      ? await this.get4KMediaContent(this.episodeTitle["4kProgramId"])
      : this.episodeTitle.mediaContent[0];
    return {
      videoType: "series",
      manifest: media.content.video.streamingUrl,
      releasePid: media.content.video.releasePid,
      releaseUrl: media.content.video.releaseUrl,
      duration: media.content.video.duration,
      filmstrip: media.content.filmstrip,
      description: this.episodeTitle.shortDescription || this.episodeTitle.description,
      title: this.episodeTitle.title,
      tvSeasonNumber: this.episodeTitle.tvSeasonNumber,
      tvSeasonEpisodeNumber: this.episodeTitle.tvSeasonEpisodeNumber,
      playbackTime: this.episodeTitle.progress && this.episodeTitle.progress.playbackTime,
      seriesTitle: location.state.seriesTitle,
      episodeLabel: getEpisodeLabel(this.episodeTitle.tvSeasonNumber, this.episodeTitle.tvSeasonEpisodeNumber),
      seasonsList: this.seasonsList,
      episodesList: this.episodesList || location.state.episodesList,
      id: this.episodeTitle.id,
      seriesId: location.state.seriesId,
      moduleId: location.state.moduleId,
      has4K: location.state.has4K,
      //externalSubtitles: is4K && media.content.subtitles
      externalSubtitles: media.content.subtitles,
      mediaGuid: media.mediaGuid,
      credits: media.credits,
      playFrom: PLAY_FROM_LABEL
    };
  }

  async get4KMediaContent(id) {
    let title;
    try {
      if (this.episodesList && this.episodesList.length) {
        title = this.episodesList.find(episode => !!episode["4kProgramId"] && episode["4kProgramId"] === id);
      } else {
        title = await sdk.mediaManager.getTitle(id, { is4K: true });
      }
      return title.title4K ? title.title4K.mediaContent[0] : title.mediaContent[0];
    } catch (e) {
      if (this.mounted) {
        showAndReportUserRelatedError.call(this, {
          modalText: i18n.get("global.errors.genericError"),
          buttons: [
            {
              ...getGlobalButtonInfo("close"),
              buttonHandler: this.closeModal
            }
          ]
        });
        this.props.setFocus(getGlobalButtonFocusPath("close"));
      }
    }
  }

  onBack() {
    const {
      match: {
        params: { titleId }
      },
      stateActions,
      applicationState,
      location,
      history
    } = this.props;
    trackEvent(PAGE, "back", titleId);
    !!getAppState().globalModal && stateActions.hideGlobalModal();
    const isDeepLinkReferrer = location.state && !!location.state.deepLinkReferrer;
    applicationState.userMediaCached = null;

    if (isDeepLinkReferrer) {
      history.push(stateActions.getHomePath(isDeepLinkReferrer, !!this.isSeries), {
        deepLinkReferrer: false
      });
      return true;
    }
    this.isExiting = true;
    const to = location.state?.from?.name === "/" ? "/home" : location.state?.from?.name;
    if (to === "/search") {
      history.goBack();
      return true;
    }
    if (to) {
      history.replace(to, {
        ...(location.state || {})
      });
      return true;
    }
    history.goBack();
    return true;
  }

  async fetchData() {
    sdk = await getSdk();
    try {
      const {
        applicationState: { userLogged, country, addons },
        match: {
          params: { titleId }
        }
      } = this.props;
      const requests = [
        sdk.mediaManager.getTitle(titleId, {
          is4K: true,
          offline: !getAppState().isOnline
        }), // [0] Title
        userLogged ? await getUserMediaLists(titleId, checkMediaListsData.bind(this)) : true, // [1] User Media
        this.isSeries ? getSeasonsList.call(this, titleId) : [] // [2] Seasons Series
      ];

      const results = requests.map(async req => await req);
      const title = await results[0];
      this.isThisDeviceSupported = userLogged
        ? await isSupportedDeviceForMobileLite.call(this, title.addonContent)
        : true;

      if (this.isSeries) {
        // FIXME: This should be done in the middleware instead.
        title.mediaContent.sort(sorter(MEDIAGUID));

        // Map the 4K episodes.
        this.title4K = {};
        !!title.title4K &&
          !!title.title4K.mediaContent &&
          title.title4K.mediaContent.forEach(
            media => (this.title4K[getSeasonEpisodeFromMediaGuid(media.mediaGuid)] = media)
          );
      }
      userLogged && (await results[1]);
      const seasons = await results[2];
      const videoType = getSupportedVideoTechnology();

      const firstEpisode =
        this.isSeries && findFirstEpisodeBySeason(title.mediaContent, this.seasonsListRaw[0].tvSeasonNumber);
      const firstEpisodeFromMediaGuid = firstEpisode && getSeasonEpisodeFromMediaGuid(firstEpisode.mediaGuid);
      const firstEpisodeNumber = firstEpisodeFromMediaGuid && parseInt(firstEpisodeFromMediaGuid.split("E")[1]);
      const firstEpisodeAvailable =
        this.isSeries && !this.resumeEpisode
          ? getEpisodeLabel(this.seasonsListRaw[0].tvSeasonNumber, !isNaN(firstEpisodeNumber) && firstEpisodeNumber)
          : undefined;

      const mediaHD = getMediaContentData.call(this, title, false);
      const media4K = !!title.title4K && getMediaContentData.call(this, title.title4K, true);
      this.mediaData = {
        mediaHD,
        media4K,
        videoHD: mediaHD.content.video[videoType] || mediaHD.content.video,
        video4K: !!media4K && (media4K.content.video[videoType] || media4K.content.video)
      };

      /* 
        First check assetTypes, check the first element of the array, if it is TVOD then check user rented
        or buy that content, if it buy then TVOD flow, if he does not buy then check if array contains 
        the SVOD in array, if array
      */
      /*
        A content is tagged with both TVOD & SVOD, Priority is set to TVOD
        We do a check whats is the subscription this content is tagged with
        Next check we check whether the user is active on the respective subscription
        No: TVOD priority
        Yes: Same as today with ability to play since its an svod and respective subscription already active
      */

      const tvodStatus = userLogged && isTVODContent(title.assetTypes) && (await getTVODAssetsStatus(title.id));
      const isTvodFlow = isTvodFlowForPlayback(tvodStatus);
      let isTVOD = isTvodFlow;
      let priceData = null;
      if (!isTvodFlow) {
        const isAssetActive = isSVODContent(title.assetTypes) ? isContentActive(addons, title.addonContent) : false;
        isTVOD =
          !isAssetActive && title.assetTypes && title.assetTypesPriority && isTVODPriority(title.assetTypesPriority)
            ? isTVODContent(title.assetTypes)
            : false;
        const assetPrices = !isAssetActive && isTVOD && (await getAssetPrices(title, country, isTVOD, tvodStatus));
        if (assetPrices && assetPrices.length !== 0) {
          priceData = this.tvodBtnText(assetPrices);
        }
      }

      if (tvodStatus && tvodStatus.length > 0) {
        // cll this add expiry time to title
        tvodStatus && getExpireTagTime(title, tvodStatus);
        tvodStatus && getYouboraPrams(title, tvodStatus);
        tvodStatus && setCurrentStatusForPlayer(tvodStatus);
      }

      let tvodType = config.get().isContentTypeTVOD;
      let svodType = config.get().isContentTypeSVOD;
      //title.mediaContent[0].expirationDate = 1689841378000;
      if ((isTVODContent(title.assetTypes) || isTVODPriority(title.assetTypesPriority)) && tvodType) {
        if (
          tvodStatus.length === 0 ||
          (tvodStatus && tvodStatus.length > 0 && tvodStatus[0]?.status?.toLowerCase() === EXPIRED)
        ) {
          title &&
            title.mediaContent.length > 0 &&
            title.mediaContent[0].expirationDate &&
            config.get().isExpiryTimeShown &&
            expirationDate(title);
        }
      } else if ((isSVODContent(title.assetTypes) || isSVODPriority(title.assetTypesPriority)) && svodType) {
        title &&
          title.mediaContent.length > 0 &&
          title.mediaContent[0].expirationDate &&
          config.get().isExpiryTimeShown &&
          expirationDate(title);
      }

      this.setState({
        backgroundCover: title.images.hero,
        firstEpisodeAvailable,
        trailer: getTrailer(title),
        title: title.title,
        description: title.shortDescription,
        id: title.id,
        has4K: !!title[HAS_4K],
        addonContent: title.addonContent,
        isLive: title.isLive,
        contentType: title.programType,
        isTVOD: isTVOD,
        assetPrices: priceData,
        tvodStatus: tvodStatus
      });
      return formatDetailData.call(this, title, seasons, priceData);
    } catch (e) {
      Sentry.captureException(e);
      !this.isExiting && showRetryOrBackModal.call(this, e);
    }
  }

  tvodBtnText(assetPrices) {
    let rentLabel;
    let oldRentLabel;
    let purchaseLabel;
    let oldPurchaseLabel;

    const rentCtaData = {};
    const purchaseCtaData = {};

    if (assetPrices && assetPrices.length !== 0) {
      assetPrices.forEach(price => {
        if (price.isRentId === true) {
          rentLabel = `${price.currency} ${price.amount}`;
          rentCtaData.newPriceId = price.priceProduct;
          rentCtaData.newPrice = price.amount;
          rentCtaData.newPriceCurrency = price.currency;
        }
        if (price.isOldRentId === true) {
          oldRentLabel = `${price.currency} ${price.amount}`;
          rentCtaData.oldPriceId = price.priceProduct;
          rentCtaData.oldPrice = price.amount;
          rentCtaData.oldPriceCurrency = price.currency;
        }
        if (price.isPurchaseId === true) {
          purchaseLabel = `${price.currency} ${price.amount}`;
          purchaseCtaData.newPriceId = price.priceProduct;
          purchaseCtaData.newPrice = price.amount;
          purchaseCtaData.newPriceCurrency = price.currency;
        }
        if (price.isOldPurchaseId === true) {
          oldPurchaseLabel = `${price.currency} ${price.amount}`;
          purchaseCtaData.oldPriceId = price.priceProduct;
          purchaseCtaData.oldPrice = price.amount;
          purchaseCtaData.oldPriceCurrency = price.currency;
        }
      });
    }
    return { rentLabel, oldRentLabel, rentCtaData, purchaseLabel, oldPurchaseLabel, purchaseCtaData };
  }

  assetHandler(type, data) {
    const {
      applicationState: { userLogged }
    } = this.props;
    const event_type = type === "rent" ? "rent_now_click" : type === "purchase" && "buy_now_click";

    if (userLogged) {
      trackAndRedirectHandler.call(
        this,
        PAGE,
        event_type,
        routes.buyasset,
        buyAssetDetails.call(this, type, data),
        type
      );
    } else {
      showNotLoggedModal.call(this, getNavigationReferences.call(this));
    }
  }

  DisclaimerText() {
    const { assetPrices } = this.state;
    const rentDisclaimerDays = config.get().rentDisclaimerTime.days;
    const rentDisclaimerHours = config.get().rentDisclaimerTime.hours;
    let text;

    if (assetPrices) {
      if (Object.keys(assetPrices.rentCtaData).length !== 0 && Object.keys(assetPrices.purchaseCtaData).length !== 0) {
        text = i18n.get("pages.detail.disclaimer.rentAndBuy", rentDisclaimerDays, rentDisclaimerHours);
      } else if (
        Object.keys(assetPrices.rentCtaData).length !== 0 &&
        Object.keys(assetPrices.purchaseCtaData).length === 0
      ) {
        text = i18n.get("pages.detail.disclaimer.rent", rentDisclaimerDays, rentDisclaimerHours);
      } else {
        text = i18n.get("pages.detail.disclaimer.purchase");
      }
    }

    return text;
  }

  render() {
    this.lastEpisode = this.props?.location?.state?.lastEpisode;
    const { assetPrices, tvodStatus } = this.state;

    return (
      <DetailWrapperStyled url={this.state.backgroundCover}>
        {this.state.isLoaded ? (
          <DetailContainerStyled position={this.state.slidePage}>
            <DetailPageStyled isSeries={this.isSeries}>
              <Detail
                data={this.state.titleData}
                playHandler={this.playHandler}
                trailerHandler={trackAndRedirectHandler.bind(
                  this,
                  PAGE,
                  "trailer",
                  routes.player,
                  getTrailerVideoData.call(this)
                )}
                addHandler={myListHandler.bind(this)}
                isSavedInMyWatchlist={this.state.isSavedInMyWatchlist}
                separator={config.get().locales[i18n.getLocale()].separator}
                direction={i18n.getDirection()}
                firstEpisodeAvailable={this.state.firstEpisodeAvailable}
                currentFocus={this.props.applicationState.currentFocus}
                isPageSlides={this.state.slidePage < 0 ? true : false}
                isUserLoggedIn={this.props.applicationState.userLogged}
                isSeries={this.isSeries}
                assetHandler={(type, data) => this.assetHandler(type, data)}
                isOnPS4={this.state.isOnPS4}
              />
              {assetPrices && (
                <DisclaimerText>
                  <IconStyled name="indicator" viewBoxValue="0 0 24 24" />
                  <DisclaimerTextStyled text={this.DisclaimerText()} />
                </DisclaimerText>
              )}
            </DetailPageStyled>
            {this.isSeries &&
              (this.state.hasEpisodes && this.seasonsList && this.episodesList && this.state.hasAllDataLoaded ? (
                <EpisodesSelector
                  seasonSelected={this.lastEpisode && this.lastEpisode.tvSeasonNumber}
                  episodeSelected={this.lastEpisode && this.lastEpisode.tvSeasonEpisodeNumber}
                  seasonsList={this.seasonsList}
                  episodesList={this.episodesList}
                  onEnterPress={this.handleEnter}
                  direction={i18n.getDirection()}
                  currentFocus={this.props.applicationState.currentFocus}
                  slideMarginStart={0}
                  MagicRemoteStatus={false}
                  fromDetailPage={true}
                  isOnPS4={this.state.isOnPS4}
                  tvodStatus={tvodStatus}
                />
              ) : (
                <ArrowScrollStyled
                  label={<Loading width="25px" height="25px" text={i18n.get("pages.detail.loadingEpisodes")} />}
                />
              ))}
          </DetailContainerStyled>
        ) : (
          <Loading overlay />
        )}
      </DetailWrapperStyled>
    );
  }
}

const Component = withAppState(withSubtheme(DetailPage));

Component.defaultFocusPath = Detail.defaultFocusPath;

export default Component;
